import React, { useState } from 'react';
import articleService from '../../../services/articleService';
import { useTheme } from '../../../contexts/ThemeContext';

const DeleteArticleModal = ({ isOpen, article, onClose, onSuccess }) => {
  const { isDarkMode } = useTheme();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setLoading(true);
    setError('');

    try {
      const result = await articleService.deleteArticle(article.id);
      if (result.success) {
        onSuccess();
      } else {
        setError(result.message);
      }
    } catch (error) {
      setError('Erreur lors de la suppression de l\'article');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !article) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-lg p-6 w-full max-w-md mx-4`}>
        <div className="flex items-center justify-between mb-4">
          <h2 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Supprimer l'Article</h2>
          <button
            onClick={onClose}
            className={`${isDarkMode ? 'text-gray-400 hover:text-gray-200' : 'text-gray-400 hover:text-gray-600'}`}
          >
            <i className="fas fa-times text-xl"></i>
          </button>
        </div>

        {error && (
          <div className={`mb-4 p-3 rounded-lg border ${isDarkMode ? 'bg-red-900 border-red-800 text-red-200' : 'bg-red-50 border-red-200 text-red-700'}`}>
            <div className="flex items-center">
              <i className={`fas fa-exclamation-circle mr-2 ${isDarkMode ? 'text-red-300' : 'text-red-500'}`}></i>
              <span>{error}</span>
            </div>
          </div>
        )}

        <div className="mb-6">
          <div className={`flex items-center justify-center w-16 h-16 mx-auto mb-4 rounded-full ${isDarkMode ? 'bg-red-950' : 'bg-red-100'}`}>
            <i className="fas fa-exclamation-triangle text-red-600 text-2xl"></i>
          </div>

          <p className={`text-center mb-4 ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
            Êtes-vous sûr de vouloir supprimer cet article ?
          </p>

          <div className={`${isDarkMode ? 'bg-gray-700' : 'bg-gray-50'} rounded-lg p-4`}>
            <div className="flex items-center justify-between mb-2">
              <span className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Désignation:</span>
              <span className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{article.designation}</span>
            </div>
            <div className="flex items-center justify-between mb-2">
              <span className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Type:</span>
              <span className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                {article.typeArticle?.designation || 'N/A'}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Code à barres:</span>
              <code className={`${isDarkMode ? 'bg-gray-800 text-gray-100 border-gray-700' : 'bg-white text-gray-900 border-gray-200'} px-2 py-1 rounded text-xs font-mono border`}>
                {article.codeABarre}
              </code>
            </div>
          </div>

          <p className="text-center text-red-600 text-sm mt-4 font-medium">
            Cette action est irréversible !
          </p>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            className={`border px-4 py-2 rounded-lg transition-colors text-sm font-medium ${
              isDarkMode
                ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-600'
                : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
            }`}
          >
            Annuler
          </button>
          <button
            onClick={handleDelete}
            disabled={loading}
            className={`px-4 py-2 rounded-lg transition-all text-white font-medium ${
              loading
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-red-600 hover:bg-red-700'
            }`}
          >
            {loading ? (
              <div className="flex items-center">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Suppression...
              </div>
            ) : (
              <div className="flex items-center">
                <i className="fas fa-trash mr-2"></i>
                Supprimer
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteArticleModal;